module.exports = __webpack_public_path__ + "db104765e5b28c79e2cfebb63d347477.pdf";